module.exports = __webpack_public_path__ + "static/3f6b5a33.banner_title_fr.png";